export const SET_PREVIEW_MODE = 'REPORTING_SET_PREVIEW_MODE';

export const setPreviewMode = isActive => ({
  type: SET_PREVIEW_MODE,
  isActive,
});
